import { HFlow, Modal, ModalBody, ModalFooter, Text, VFlow } from 'bold-ui'
import useSession from 'components/auth/useSession'
import { FooterButton } from 'components/footer-button'
import { PageLoading } from 'components/loading'
import { RegistrosDoseQuery } from 'graphql/types.generated'
import React, { useState } from 'react'
import { LoteImunobiologicoFabricanteSelectFieldModel } from 'view/lote-imunobiologico/insert/LoteImunobiologicoFabricanteSelectField'
import { covidImunosRecord } from 'view/lote-imunobiologico/insert/LoteImunologicoTooltipAddForm'

import { InfoCardModalVacinacao } from '../detail/vacinacao/VacinacaoCalendarioView'
import { AplicacaoVacinaModal } from './AplicacaoVacinaModal'
import { AprazamentoVacinaModal } from './AprazamentoVacinaModal'
import { createModalProps } from './condicoes/converter'
import { RegistroVacinacaoFormModel, TipoRegistroDoseEnum } from './model'
import { RegistroAnteriorVacinaModal } from './RegistroAnteriorVacinaModal'
import { AprazamentoDose, RegistroDose, RegistroDoseProps } from './RegistroDose'
import { VacinacaoModalHeader } from './VacinacaoModalHeader'

export interface VacinacaoModalItem {
  idImunobiologico: ID
  nomeImunobiologico: string
  siglaImunobiologico: string
  estrategia: string
  idDose: ID
  nomeDose: string
  faixaEtaria: string
  registros: RegistroDoseProps[]
}
interface VacinacaoModalProps {
  registrosDoseQueryResult: RegistrosDoseQuery
  modalOpen: boolean
  handleModalClose(): void
  handleOnSubmit(formValues: RegistroVacinacaoFormModel): void
  setIsVacinacaoModalOpen(value: boolean): void
  loading: boolean
  infoCardModal: InfoCardModalVacinacao
  registrosModificados: RegistroVacinacaoFormModel[]
}

type subModalVacinacaoOptions = 'APRAZAMENTO' | 'APLICACAO' | 'ANTERIOR'

export const VacinacaoModal = (props: VacinacaoModalProps) => {
  const { modalOpen, loading, infoCardModal, registrosModificados } = props
  const [currentModalOpen, setCurrentModalOpen] = useState<subModalVacinacaoOptions>(null)
  const { data } = useSession()
  const lotacaoProfissional = data.acesso.__typename === 'Lotacao' && data.acesso

  let modalInfo = createModalProps(
    infoCardModal,
    props?.registrosDoseQueryResult,
    registrosModificados,
    data.profissional.nome,
    lotacaoProfissional.cbo.nome,
    lotacaoProfissional.unidadeSaude.nome
  )

  const handleSubModalVacinacaoOpen = (value: subModalVacinacaoOptions) => {
    props.setIsVacinacaoModalOpen(false)
    setCurrentModalOpen(value)
  }

  const handleSubModalVacinacaoClose = () => {
    props.setIsVacinacaoModalOpen(true)
    setCurrentModalOpen(null)
  }

  return (
    <>
      <Modal open={modalOpen} onClose={props.handleModalClose} size='auto'>
        <ModalBody>
          <VFlow>
            <VacinacaoModalHeader {...modalInfo} />
            {!loading ? (
              modalInfo.registros?.length > 0 ? (
                modalInfo?.registros.map((registro, index) => {
                  return registro?.dataAplicacao ? (
                    <RegistroDose {...registro} key={index} />
                  ) : (
                    <AprazamentoDose {...registro} key={index} />
                  )
                })
              ) : (
                <Text fontStyle='italic'>Essa dose não possui nenhum registro.</Text>
              )
            ) : (
              <PageLoading message='Carregando' />
            )}
          </VFlow>
        </ModalBody>

        <ModalFooter>
          <HFlow justifyContent='space-between'>
            <FooterButton kind='normal' onClick={() => handleSubModalVacinacaoOpen('ANTERIOR')}>
              Registro anterior
            </FooterButton>
            <HFlow>
              <FooterButton kind='primary' onClick={() => handleSubModalVacinacaoOpen('APLICACAO')}>
                Aplicar
              </FooterButton>
              <FooterButton kind='primary' onClick={() => handleSubModalVacinacaoOpen('APRAZAMENTO')}>
                Aprazar
              </FooterButton>
            </HFlow>
          </HFlow>
        </ModalFooter>
      </Modal>

      <RegistroAnteriorVacinaModal
        {...modalInfo}
        initialValues={
          {
            imunobiologico: infoCardModal?.imunobiologicoId,
            doseImunobiologico: infoCardModal?.doseId,
            tipoRegistroVacinacao: TipoRegistroDoseEnum.REGISTRO_ANTERIOR,
            fabricante: {
              nome: covidImunosRecord[props?.infoCardModal?.imunobiologicoId],
            } as LoteImunobiologicoFabricanteSelectFieldModel,
          } as RegistroVacinacaoFormModel
        }
        modalOpen={currentModalOpen === 'ANTERIOR'}
        handleModalClose={() => handleSubModalVacinacaoClose()}
        handleOnSubmit={props.handleOnSubmit}
      />

      <AprazamentoVacinaModal
        {...modalInfo}
        modalOpen={currentModalOpen === 'APRAZAMENTO'}
        handleModalClose={() => handleSubModalVacinacaoClose()}
        handleOnSubmit={props.handleOnSubmit}
      />

      <AplicacaoVacinaModal
        {...modalInfo}
        modalOpen={currentModalOpen === 'APLICACAO'}
        handleModalClose={() => handleSubModalVacinacaoClose()}
        handleOnSubmit={props.handleOnSubmit}
      />
    </>
  )
}
